module.exports = __webpack_public_path__ + "static/assets/2296a0aa7efc4539debb5ef94a56da61.png";